import React from 'react';
import UpdateApp from '../components/updateApp';
import * as ROUTES from '../../../../constants/routes';
import PushNotification from '../components/pushNotification';
import Subscription from '../components/subscription';
import Settings from '../components/Settings';
import CustomizeApp from '../components/customizeApp';
import CustomerData from '../components/CustomerData';

const WordPress = props => {
  const {
    appId,
    subscriptionExpired,
    toggleSideBar,
    history,
    nameChanged,
    isAdmin,
    hideComponents
  } = props;
  return (
    <React.Fragment>
      {!hideComponents && (
        <React.Fragment>
          <CustomizeApp
            subscriptionExpired={subscriptionExpired}
            history={history}
            toggleSideBar={toggleSideBar}
            nameChanged={nameChanged}
          />
          <UpdateApp
            appId={appId}
            link={ROUTES.linkToUpdateApp()}
            subscriptionExpired={subscriptionExpired}
          />
          <PushNotification
            onClick={toggleSideBar}
            link={ROUTES.linkToPushNotification()}
          />
        </React.Fragment>
      )}
      <Subscription
        link={ROUTES.linkToSubscription()}
        onClick={toggleSideBar}
      />
      <Settings link={`${ROUTES.linkToSettings()}`} onClick={toggleSideBar} />
      {isAdmin && (
        <React.Fragment>
          <CustomerData
            link={`${ROUTES.linkToCustomerData()}`}
            onClick={toggleSideBar}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default WordPress;
